import { KB, MB } from "./constant"

export const Size = (value, unit) => ({ VALUE: value, UNIT: unit });

export const MODULE_THUMBNAIL_SIZE = Size(100, KB);
export const MODULE_MEDIA_SIZE = Size(10, MB);
export const MODULE_ASSET_SIZE = Size(300, MB);
export const AR_CONTENT_THUMBNAIL = Size(100, KB);
export const AR_CONTENT_MEDIA = Size(100, MB);
export const AR_CONTENT_3D_MODEL = Size(100, MB);
export const AR_CONTENT_HOTSPOT_FILE = Size(5, MB);